import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Resultfsk() {
  return (
    <div className="result_fsk p-100">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="result-fsk-content">
              <h2>
                Results <span>Impact</span>
              </h2>
              <p>
                The innovative solutions implemented in "FSK" have yielded
                remarkable outcomes, affirming the success of TekRevol's
                collaboration with the client. Players actively engage with the
                captivating gaming experience, driven by the harmonious blend of
                match-3 puzzles, time management challenges, and role-playing
                elements. Positive player feedback underscores the game's appeal
                and positive reception within the mobile gaming community.
                Successful and thoughtful monetization strategies have created a
                sustainable revenue model, and "FSK" has not only established
                itself as a notable presence but also fostered a growing player
                community, enriching the overall gaming experience.
              </p>
               </div>
          </Col>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="">
            <div className="result-fsk-img">
              <StaticImage
                src="../../../images/case-studies/fsk/result-impact.webp"
                alt="TekRevol"
                className="logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={857}
                height={623}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Resultfsk;
